$(function () {
    refreshLiveLabels();
    
    setInterval(() => {
      refreshLiveLabels();
    }, 60 * 60 * 1000);
  }); 

/* ---------------- ADDING LIVE LABEL - "TRWA" ---------------------------------------------- */
function refreshLiveLabel($el) {
    const duration = $el.data('event-duration');
    const [from, to] = $el.data('live-label').split('|');
    const now = new Date().getTime();
    const fromTimestamp = new Date(from).getTime();  
    const toTimestamp = new Date(to).getTime(); 

    // console.log(toTimestamp);

    if (now >= fromTimestamp && now < toTimestamp){
        if (!$el.hasClass('live') && duration !== 'unbounded') {
            $el.addClass('live').find('.boxData').append('<span class="liveIndicator" data-live-indicator>TRWA</span>');
        }
    } else {
        $el.removeClass('live').find('[data-live-indicator]').remove();
    } 
}

function refreshLiveLabels() {
    $('[data-live-label]').each((i, el) => {
        refreshLiveLabel($(el));
    });
}
  